<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            {
              component: 'h3',
              innerText: 'Elementy'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              blankObject: { rows: [] },
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['title']),
                fields: [
                  new fields.Input({
                    label: 'Tytuł',
                    modelPath: [this, 'form', 'items', i, 'title']
                  }),
                  new fields.Link({
                    label: 'Link',
                    modelPath: [this, 'form', 'items', i, 'link']
                  }),
                  {
                    component: 'h3',
                    innerText: 'Wiersze'
                  },
                  this.getRowFormset(i)
                ]
              }))
            })
          ]
        }
      ]
    }
  },
  methods: {
    getRowFormset(i) {
      return new fields.Formset({
        modelPath: [this, 'form', 'items', i, 'rows'],
        items: this.form.items[i].rows.map((row, rowIndex) => ({
          headerLabel: get(row, ['column_1']),
          fields: [
            new fields.Input({
              label: 'Kolumna 1',
              modelPath: [
                this,
                'form',
                'items',
                i,
                'rows',
                rowIndex,
                'column_1'
              ]
            }),
            new fields.Input({
              label: 'Kolumna 2',
              modelPath: [
                this,
                'form',
                'items',
                i,
                'rows',
                rowIndex,
                'column_2'
              ]
            }),
            new fields.Switch({
              label: 'Wyróżniony wiersz',
              modelPath: [
                this,
                'form',
                'items',
                i,
                'rows',
                rowIndex,
                'is_highlighted'
              ]
            })
          ]
        }))
      })
    }
  }
}
</script>
